import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { MultiSelect } from 'primereact/multiselect';

import './digital-skills-resource-location-select.css';

// TODO: Move this component to the UI Library and make it reusable & enable multi-select once api is updated

interface DigitalSkillsResourceLocationSelectProps {
  value: string[];
  options: {
    label: string;
    value: string;
  }[];
  onChange: (value: string[]) => void;
  label: string;
}

const DigitalSkillsResourceLocationSelect: React.FC<DigitalSkillsResourceLocationSelectProps> = ({
  value,
  options,
  onChange,
  label,
}) => {
  const customSelectedItemsLabel = () => {
    return <>Resource location</>;
  };

  const itemTemplate = (option: { label: string; value: string }) => {
    const labelId = `dsrl_${option.value}`;
    const isSelected = value.includes(option.value);

    return (
      <div className="digitalSkillsResourceTypeSelectOption">
        <div
          id={labelId}
          className="optionItem"
        >
          {option.label}
        </div>
        <Checkbox
          aria-labelledby={labelId}
          style={{
            display: 'none',
          }}
          checked={isSelected}
          onChange={() => {
            if (isSelected) {
              onChange(value.filter((v) => v !== option.value));
            } else {
              onChange([...value, option.value]);
            }
          }}
        />

        {isSelected ? (
          <i
            className="fa-solid fa-check-square"
            style={{ color: 'var(--light-text-highlight)' }}
          ></i>
        ) : (
          <i className="fa-regular fa-square"></i>
        )}
      </div>
    );
  };

  return (
    <div className="digitalSkillsResourceLocationSelect">
      <MultiSelect
        id="resourceLocationMultiSelect"
        appendTo="self"
        value={value}
        onChange={(e) => onChange(e.value)}
        options={options}
        optionLabel="label"
        placeholder="Select Resource Location"
        className="libraryPage"
        selectedItemTemplate={customSelectedItemsLabel}
        maxSelectedLabels={0}
        selectedItemsLabel={`{value.length} Resource location`}
        itemTemplate={itemTemplate}
        itemCheckboxIcon="pi pi-check"
        aria-label={label}
        role="search"
        pt={{
          input: {
            autocomplete: 'off',
            'aria-label': label,
            'aria-controls': 'resourceLocationMultiSelect',
          },
          list: {
            'aria-label': label,
          },
          wrapper: {
            tabIndex: 0,
            role: 'complementary',
          },
        }}
      />
    </div>
  );
};

export default DigitalSkillsResourceLocationSelect;
